// @flow

import { Row, Col } from 'clark-styles';
import styled from 'styled-components';

import { SPACING_SMALL, SPACING_MEDIUM, SPACING_LARGE } from 'styles/spacing';
import { FONT_WEIGHT_100, FONT_WEIGHT_400 } from 'styles/font-weight';
import { GREY_10, GREY_75, WHITE } from 'styles/colors';
import { TYPE_SCALE_F6 } from 'styles/type-scale';
import { BORDER_WIDTH_1 } from 'styles/borders';
import media from 'styles/media-queries';

export const Offset = styled.span`
  padding-left: ${SPACING_LARGE};
  display: inline-block;
`;

export const CenteredCol = styled<any>(Col)`
  display: flex;
  justify-content: center;
`;

export const TableHeader = styled<any>(Row)`
  ${FONT_WEIGHT_400};
  color: ${GREY_75};
  padding: ${SPACING_SMALL} 0;
  ${TYPE_SCALE_F6};
  letter-spacing: 1px;
`;

export const TableRow = styled<any>(Row)`
  ${FONT_WEIGHT_100};
  color: ${GREY_75};
  ${TYPE_SCALE_F6};
  padding: ${SPACING_MEDIUM} 0;
  border: solid ${GREY_10} ${BORDER_WIDTH_1};
  margin-top: -${BORDER_WIDTH_1};
  background-color: ${WHITE};
`;

export const SmallOnly = styled.div`
  ${media.small`
    display: none;
  `};
`;

export const SmallHide = styled.div`
  display: none;

  ${media.small`
    display: block;
  `};
`;

export const Wrapper = styled.div`
  margin: ${SPACING_MEDIUM} 0;

  ${media.small`
    margin: ${SPACING_LARGE} 0;
  `};
`;



// WEBPACK FOOTER //
// ./src/styles/table/index.js